export const SUPPORTED_TIMEZONES = [
  { value: 'America/Los_Angeles', label: 'PST - Pacific Standard Time' },
  { value: 'America/Denver', label: 'MST - Mountain Standard Time' },
  { value: 'America/Chicago', label: 'CST - Central Standard Time' },
  { value: 'America/New_York', label: 'EST - Eastern Standard Time' },
  { value: 'America/Anchorage', label: 'AKST - Alaska Standard Time' },
  { value: 'America/Adak', label: 'HAST - Hawaii-Aleutian Standard Time' },
  { value: 'America/Phoenix', label: 'MST - Arizona Time' },
  { value: 'America/Halifax', label: 'AST - Atlantic Standard Time' },
  { value: 'America/St_Johns', label: 'NST - Newfoundland Standard Time' },
  { value: 'Pacific/Samoa', label: 'SST - Samoa Standard Time' },
  { value: 'Pacific/Guam', label: 'ChST - Chamorro Standard Time' },
];

const TIMEZONE_ALIASES = {
  pacific: 'America/Los_Angeles',
  pst: 'America/Los_Angeles',
  pt: 'America/Los_Angeles',
  'pacific time': 'America/Los_Angeles',
  'us/pacific': 'America/Los_Angeles',
  'america/vancouver': 'America/Los_Angeles',
  'us/mountain': 'America/Denver',
  'america/boise': 'America/Denver',
  'america/edmonton': 'America/Denver',
  central: 'America/Chicago',
  cst: 'America/Chicago',
  ct: 'America/Chicago',
  'central time': 'America/Chicago',
  'us/central': 'America/Chicago',
  'america/winnipeg': 'America/Chicago',
  eastern: 'America/New_York',
  est: 'America/New_York',
  et: 'America/New_York',
  'eastern time': 'America/New_York',
  'us/eastern': 'America/New_York',
  'america/detroit': 'America/New_York',
  'america/toronto': 'America/New_York',
  alaska: 'America/Anchorage',
  akst: 'America/Anchorage',
  'alaska time': 'America/Anchorage',
  'us/alaska': 'America/Anchorage',
  'hawaii-aleutian': 'America/Adak',
  hast: 'America/Adak',
  'hawaii-aleutian time': 'America/Adak',
  'us/aleutian': 'America/Adak',
  arizona: 'America/Phoenix',
  'arizona time': 'America/Phoenix',
  'us/arizona': 'America/Phoenix',
  atlantic: 'America/Halifax',
  ast: 'America/Halifax',
  'atlantic time': 'America/Halifax',
  'canada/atlantic': 'America/Halifax',
  newfoundland: 'America/St_Johns',
  nst: 'America/St_Johns',
  'newfoundland time': 'America/St_Johns',
  'canada/newfoundland': 'America/St_Johns',
  samoa: 'Pacific/Samoa',
  sst: 'Pacific/Samoa',
  'samoa time': 'Pacific/Samoa',
  'pacific/pago_pago': 'Pacific/Samoa',
  guam: 'Pacific/Guam',
  chst: 'Pacific/Guam',
  'chamorro time': 'Pacific/Guam',
};

export function normalizeSupportedTimezone(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  const candidate = value.trim();
  const exact = SUPPORTED_TIMEZONES.find(timezone => (
    timezone.value.toLowerCase() === candidate.toLowerCase()
    || timezone.label.toLowerCase() === candidate.toLowerCase()
  ));
  return exact?.value || TIMEZONE_ALIASES[candidate.toLowerCase()] || '';
}

export function suggestedDeviceTimezone() {
  try {
    return normalizeSupportedTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch (_error) {
    return '';
  }
}

export function supportedTimezoneLabel(value) {
  const normalized = normalizeSupportedTimezone(value);
  return SUPPORTED_TIMEZONES.find(timezone => timezone.value === normalized)?.label || value;
}
